/* eslint-disable import/prefer-default-export */
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from './TextInput';
import { useValidationMessagingArgs, ValidationStates } from './ValidationMessages';

interface EmailProps {
    initialValue?: string;
}

const verification: useValidationMessagingArgs = {
    applicableStates: [ValidationStates.MissingRequired, ValidationStates.EmailExists],
};

export const UserEmail: React.FC<EmailProps> = ({ initialValue }) => {
    const { t } = useTranslation(['forms']);

    return (
        <TextInput
            formFieldId="email"
            isRequired
            inputValidation={verification}
            label={t('forms:inputs.email.label')}
            name="Email"
            initialValue={initialValue}
        />
    );
};
